





























































































































































































































































































































































































































































import {
  Component, Prop, Vue, PropSync,
} from 'vue-property-decorator';
import {
  Market, Settings, SettingsApi,
} from '@compassdigital/foodworks.ts.sdk';
import EditConfirmation from '@/components/Form/EditConfirmation/index.vue';
import PreviewTable from '@/components/Form/ScheduleSetting/PreviewTable/index.vue';
import VuetifySelect from '@/components/Form/VuetifySelect/index.vue';
import Dropdown from '@/components/Form/Dropdown/index.vue';
import RotationPreview from '@/components/Form/ScheduleSetting/RotationPreview/index.vue';
import AppModule from '@/store/modules/app';
import SystemModule from '@/store/modules/system';
import MarketUtil from '@/util/MarketUtil';
import Format from '@/util/Format';

@Component({
  components: {
    EditConfirmation,
    Dropdown,
    VuetifySelect,
    RotationPreview,
    PreviewTable,
  },
})
export default class ScheduleEdit extends Vue {
  @PropSync('service', {}) serviceLocal: any;

  @PropSync('partner', {}) partnerLocals: any;

  @Prop({}) requiredDay!: string;

  @Prop({}) requireWeek!: string;

  @Prop({}) saving!: boolean;

  public cuisinesArray: Settings [] = [];

  public enableSchedule: boolean = false;

  public rotationDifferent: any = 'different';

  public allDays: any = {
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
  }

  public weekOccur: any = {
    week1: false,
    week2: false,
    week3: false,
    week4: false,
    week5: false,
  }

  private popupStationItems = [
    {
      text: 1,
      value: 1,
    },
    {
      text: 2,
      value: 2,
    },
    {
      text: 3,
      value: 3,
    },
    {
      text: 4,
      value: 4,
    },
    {
      text: 5,
      value: 5,
    },
  ];

  private cuisine = [
    {
      text: 'Mexican',
      value: 'Mexican',
    },
    {
      text: 'Mexican-1',
      value: 'Mexican-2',
    },
  ];

  private itemsSwitch = [
    {
      text: 'different',
      value: 'different',
    },
    // {
    //   text: 'same',
    //   value: 'false',
    // },
  ];

  popupStationRules = [(v: any) => !!v || 'Can not be left empyty'];

  availableDayRules = [(v: any) => !!v || 'Can not be left empyty'];

  availableWeekRules = [(v: any) => !!v || 'Can not be left empyty'];

  public onCancel() {
    this.$emit('cancel');
  }

  public onSave() {
    this.$emit('save');
  }

  public mounted() {
    this.getCuisinesItems();
    this.getUnitScheduleDays();
    this.getEnableSchedule();
    this.getOccursWeek();
    if (this.enableSchedule === true) {
      this.serviceLocal.differentRotation = true;
    }
  }

  public enableAuto(event: any) {
    const selectEnable = event.target.checked;
    if (selectEnable === true) {
      this.serviceLocal.autoSchedule = true;
      this.enableSchedule = true;
    } else {
      this.serviceLocal.autoSchedule = false;
      this.enableSchedule = false;
    }
  }

  // private items = CuisineType;
  public async getCuisinesItems() {
    const api = new SettingsApi(AppModule.apiConfig);
    const cuisine: any = await api.getSettings();
    const { cuisineTypes } = cuisine.data;
    this.cuisinesArray = cuisineTypes.sort();
  }

  public getUnitScheduleDays() {
    if (this.serviceLocal.popupPattern) {
      const days = this.serviceLocal.popupPattern;
      const mappedData = !days || days.map((day: any) => {
        if (day === 0) {
          this.allDays.sunday = true;
        }
        if (day === 1) {
          this.allDays.monday = true;
        }
        if (day === 2) {
          this.allDays.tuesday = true;
        }
        if (day === 3) {
          this.allDays.wednesday = true;
        }
        if (day === 4) {
          this.allDays.thursday = true;
        }
        if (day === 5) {
          this.allDays.friday = true;
        }
        if (day === 6) {
          this.allDays.saturday = true;
        }
        return day;
      });
    }
    return '';
  }

  public getOccursWeek() {
    if (this.serviceLocal.weeklyOccurrence) {
      const weeks = this.serviceLocal.weeklyOccurrence;
      const mappedData = !weeks || weeks.map((week: any) => {
        if (week === 1) {
          this.weekOccur.week1 = true;
        }
        if (week === 2) {
          this.weekOccur.week2 = true;
        }
        if (week === 3) {
          this.weekOccur.week3 = true;
        }
        if (week === 4) {
          this.weekOccur.week4 = true;
        }
        if (week === 5) {
          this.weekOccur.week5 = true;
        }
        return week;
      });
    }
    return '';
  }

  public getEnableSchedule() {
    if (this.serviceLocal.autoSchedule === true) {
      this.serviceLocal.autoSchedule = true;
      this.enableSchedule = true;
    } else {
      this.serviceLocal.autoSchedule = false;
      this.enableSchedule = false;
    }
  }

  public getWeekFormatted(event: any, value: any) {
    const day = event.target.value;
    if (event.target.checked === true && day) {
      if (day === '1') {
        this.weekOccur.week1 = true;
      }
      if (day === '2') {
        this.weekOccur.week2 = true;
      }
      if (day === '3') {
        this.weekOccur.week3 = true;
      }
      if (day === '4') {
        this.weekOccur.week4 = true;
      }
      if (day === '5') {
        this.weekOccur.week5 = true;
      }
      return day;
    }
    if (event.target.checked === false && day) {
      if (day === '1') {
        this.weekOccur.week1 = false;
      }
      if (day === '2') {
        this.weekOccur.week2 = false;
      }
      if (day === '3') {
        this.weekOccur.week3 = false;
      }
      if (day === '4') {
        this.weekOccur.week4 = false;
      }
      if (day === '5') {
        this.weekOccur.week5 = false;
      }
    }
    return day;
  }

  public getDayRest(event: any, value: any) {
    const day = event.target.value;
    if (event.target.checked === true && day) {
      if (day === '0') {
        this.allDays.sunday = true;
      }
      if (day === '1') {
        this.allDays.monday = true;
      }
      if (day === '2') {
        this.allDays.tuesday = true;
      }
      if (day === '3') {
        this.allDays.wednesday = true;
      }
      if (day === '4') {
        this.allDays.thursday = true;
      }
      if (day === '5') {
        this.allDays.friday = true;
      }
      if (day === '6') {
        this.allDays.saturday = true;
      }
      return day;
    }
    if (event.target.checked === false && day) {
      if (day === '0') {
        this.allDays.sunday = false;
      }
      if (day === '1') {
        this.allDays.monday = false;
      }
      if (day === '2') {
        this.allDays.tuesday = false;
      }
      if (day === '3') {
        this.allDays.wednesday = false;
      }
      if (day === '4') {
        this.allDays.thursday = false;
      }
      if (day === '5') {
        this.allDays.friday = false;
      }
      if (day === '6') {
        this.allDays.saturday = false;
      }
    }
    return day;
  }

  public dayCategories: any = [
    {
      text: 'Sun',
      value: 0,
    },
    {
      text: 'Mon',
      value: 1,
    },
    {
      text: 'Tue',
      value: 2,
    },
    {
      text: 'Wed',
      value: 3,
    },
    {
      text: 'Thu',
      value: 4,
    },
    {
      text: 'Fri',
      value: 5,
    },
    {
      text: 'Sat',
      value: 6,
    },
  ]

  public occursWeeks: any = [
    {
      text: '1st Week',
      value: 1,
    },
    {
      text: '2nd Week',
      value: 2,
    },
    {
      text: '3rd Week',
      value: 3,
    },
    {
      text: '4th Week',
      value: 4,
    },
    {
      text: '5th Week',
      value: 5,
    },
  ]

  public partnerPreview: any = [
    {
      text: 'Restaurant 1',
      value: 1,
    },
    {
      text: 'Restaurant 2',
      value: 2,
    },
    {
      text: 'Restaurant 3',
      value: 3,
    },
    {
      text: 'Restaurant 4',
      value: 4,
    },
    {
      text: 'Restaurant 5',
      value: 5,
    },
  ]
}
